import {TerrainRegion_ModUI} from "../../../../../UI/Maps/MapUI/ObjectComps/ModifierUIs/TerrainRegion_ModUI.js";
import {TerrainSpotHeight_ModUI} from "../../../../../UI/Maps/MapUI/ObjectComps/ModifierUIs/TerrainSpotHeight_ModUI.js";
import {Mod_TerrainRegion} from "./Mod_TerrainRegion.js";
import {Mod_TerrainSpotHeight} from "./Mod_TerrainSpotHeight.js";
import {ObjModifier} from "../ObjModifier.js";
import {Mod_TerrainDefinition} from "./Mod_TerrainDefinition.js";
import {TerrainDefinition_ModUI} from "../../../../../UI/Maps/MapUI/ObjectComps/ModifierUIs/TerrainDefinition_ModUI.js";
import {Mod_TerrainMaterials} from "./Mod_TerrainMaterials.js";
import {TerrainMaterials_ModUI} from "../../../../../UI/Maps/MapUI/ObjectComps/ModifierUIs/TerrainMaterials_ModUI.js";
import {Mod_TerrainSceneries} from "./Mod_TerrainSceneries.js";
import {TerrainSceneries_ModUI} from "../../../../../UI/Maps/MapUI/ObjectComps/ModifierUIs/TerrainSceneries_ModUI.js";
import {Mod_Viewpoint} from "./Mod_Viewpoint.js";
import {Viewpoint_ModUI} from "../../../../../UI/Maps/MapUI/ObjectComps/ModifierUIs/Viewpoint_ModUI.js";
import {Mod_Building} from "./Mod_Building.js";
import {Building_ModUI} from "../../../../../UI/Maps/MapUI/ObjectComps/ModifierUIs/Building_ModUI.js";
import {Mod_Level} from "./Mod_Level.js";
import {Level_ModUI} from "../../../../../UI/Maps/MapUI/ObjectComps/ModifierUIs/Level_ModUI.js";
import {Mod_Room} from "./Mod_Room.js";
import {Room_ModUI} from "../../../../../UI/Maps/MapUI/ObjectComps/ModifierUIs/Room_ModUI.js";
import {Mod_Door} from "./Mod_Door.js";
import {Door_ModUI} from "../../../../../UI/Maps/MapUI/ObjectComps/ModifierUIs/Door_ModUI.js";
import {Mod_Window} from "./Mod_Window.js";
import {Window_ModUI} from "../../../../../UI/Maps/MapUI/ObjectComps/ModifierUIs/Window_ModUI.js";
import {Mod_Opening} from "./Mod_Opening.js";
import {Opening_ModUI} from "../../../../../UI/Maps/MapUI/ObjectComps/ModifierUIs/Opening_ModUI.js";

type ModClass = new(..._)=>any; // we don't actually use a base-class, so this is all we can do atm
export const objModifierClasses: Array<{mod: ModClass, key: keyof ObjModifier, name: string, ui: React.ComponentType<any>}> = [
	{mod: Mod_TerrainDefinition, key: "terrainDefinition", name: "Terrain definition", ui: TerrainDefinition_ModUI},
	{mod: Mod_TerrainRegion, key: "terrainRegion", name: "Terrain region", ui: TerrainRegion_ModUI},
	/** V3.1 follow-up (plan §5.3.3): the `Mod_TerrainSpotHeight` class + the
	 *  `ObjModifier.terrainSpotHeight` field + the rasterizer bridge + `StripMapObjForTerrain`
	 *  were all plumbed in Phase 7, but the registry entry was missing so the modifier
	 *  couldn't be added from the UI. Added here now. */
	{mod: Mod_TerrainSpotHeight, key: "terrainSpotHeight", name: "Terrain spot height", ui: TerrainSpotHeight_ModUI},
	/** Set9 Phase 7: procedural-material recipes + placed instances + region assignments. */
	{mod: Mod_TerrainMaterials, key: "terrainMaterials", name: "Terrain materials", ui: TerrainMaterials_ModUI},
	/** Set13: user-authored scenery kinds + the global scenery budget. */
	{mod: Mod_TerrainSceneries, key: "terrainSceneries", name: "Terrain sceneries", ui: TerrainSceneries_ModUI},
	/** Set15 P0: a locked 3D-camera viewpoint (position + orientation + height). */
	{mod: Mod_Viewpoint, key: "viewpoint", name: "Viewpoint", ui: Viewpoint_ModUI},
	/** Buildings Set1 (§2.6): the building-level modifier (owns the grouped inheritable defaults;
	 *  generates floors/walls/roofs unless it's a prototype). */
	{mod: Mod_Building, key: "building", name: "Building", ui: Building_ModUI},
	/** Buildings Set1 (§2.6): a floor of a building; owns a subtree of Rooms. */
	{mod: Mod_Level, key: "level", name: "Level", ui: Level_ModUI},
	/** Buildings Set1 (§2.6): a single space within a Level. */
	{mod: Mod_Room, key: "room", name: "Room", ui: Room_ModUI},
	/** Buildings Set1 (§2.6): an opening (at floor level) in a wall of the closest ancestor Room. */
	{mod: Mod_Door, key: "door", name: "Door", ui: Door_ModUI},
	/** Buildings Set1 (§2.6): an opening in a wall of the closest ancestor Room. */
	{mod: Mod_Window, key: "window", name: "Window", ui: Window_ModUI},
	/** Buildings Set1 follow-up: a full-height opening that punches out the ENTIRE wall over its
	 *  width (no sill/frame/model) — used to stop wall-mesh generation between Rooms that are
	 *  part of the same open space. */
	{mod: Mod_Opening, key: "opening", name: "Opening", ui: Opening_ModUI},
];

/*export function GetObjModifierPanelsToShow(mod: ObjModifier): Array<React.ComponentType> {
	return [
		mod.terrainRegion && TerrainRegion_ModUI,
	].filter(a=>a) as Array<React.ComponentType>;
}*/
export function GetObjModifierPanelsToShow(mod: ObjModifier): Array<React.ComponentType> {
	return objModifierClasses
		.filter(modType=>mod[modType.key] != null)
		.map(modType=>modType.ui);
}